import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BusinessUnitCreation from "./BusinessUnitCreation/BusinessUnitCreation";
import "./BusinessUnitHome.scss";
import BusinessUnitPreferences from "./BusinessUnitPreferences/BusinessUnitPreferences";
import {
  countriesService,
  emissionAvailableCategoriesService,
} from "../../services/emissionService";
import { toastMessage } from "../../helper";
import { createOrUpdateBusinessUnitAction } from "../../actions/orgActions";
import countryList from "react-select-country-list";
import {
  fetchBusinessUnit,
  fetchDefaultCategoryPreferences,
} from "../../services/orgService";
import { CURRENCY, STEPS } from "../../constants/enums";
import { useTranslation } from "react-i18next";

const OrganisationHome = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [step, setStep] = useState(STEPS.ADD_UNIT);
  const [initialData, setInitialData] = useState<any>(null);

  const countryOptions: any = useMemo(() => countryList().getData(), []);
  const [defaultAddress, setDefaultAddress] = useState<any>();
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    code: "",
    registrationId: "",
    facilityBoundary: "",
    imageUrl: "",
    company: "",
    type: "",
    typeName: "",
    parentIndustryName: "",
    industry: null,
    childIndustryName: "",
    mobile: "",
    email: "",
    phone: "",
    dialCode: "+91",
    country: { value: "IN", label: "India" },
    address: {
      addressLine1: "",
      addressLine2: "",
      city: "",
      cityCode: "",
      state: "",
      stateCode: "",
      country: "",
      countryCode: "",
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      company: "",
    },
    parent: null,
    incharge: "",
    inchargeName: "",
    owner: "",
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
  const { id } = useParams();
  const { state } = useLocation();
  const isClone = !!state?.isClone;

  const businessUnitId = id || state?.id;

  const [categoryData, setCategoryData] = useState([] as any);
  const [countriesData, setCountriesData] = useState([]);
  const [preferenceData, setPreferenceData] = useState({
    currency: CURRENCY.CURRENCY_48,
    carbonPrice: null as any,
    directEmissionApproval: true,
    approveEmissions: false,
    gwpVersion: "",
    //categories: [] as any,
  });
  const [initCategoryPreferences, setInitCategoryPreferences] = useState([]);
  const [defaultCategoryPreferences, setDefaultCategoryPreferences] = useState(
    []
  );
  const [categoryPreferences, setCategoryPreferences] = useState([] as any[]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [isPreferenceClicked, setIsPreferenceClicked] = useState(false);
  const [currency, setCurrency] = useState(CURRENCY.CURRENCY_48);
  const [gwpVersion, setGwpVersion] = useState("");
  const [carbonPrice, setCarbonPrice] = useState(null);
  const [directEmissionApproval, setDirectEmissionApproval] = useState(true);
  let initialDirectEmissionApproval = false;
  const [industries, setIndustries] = useState([] as any[]);
  useEffect(() => {
    (async () => {
      await fetchCountries();
      let categories = await getAvailableCategories();
      if (businessUnitId || isClone) {
        fillBUnitData(categories);
      }
      // await fetchIncharges();
      // await fetchBunitTypes();
      // if (isEdit || isClone) {
      //   fillBUnitData();
      // }
    })();
  }, []);
  const fetchCountries = () => {
    return countriesService()
      .then((res) => {
        setCountriesData(res.data);
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      });
  };
  const getAvailableCategories = () => {
    let company =
      localStorage.getItem("company") &&
      JSON.parse(localStorage.getItem("company") || "").id;
    return emissionAvailableCategoriesService(company, true)
      .then((res) => {
        let preferences: any = [];
        let categories = res.data
          .map((eachCat: any, index: number) => {
            eachCat.selected = false;
            eachCat.showComments = false;
            eachCat.usageComments = "";
            eachCat.usage = null;

            preferences.push({
              category: eachCat.id,
              name: eachCat.code + " - " + eachCat.name,
              subTypes: [],
              emissionFactorSourceName: null,
              methods: [],
              logEmissionAgainst: "",
              isAdded: true,
              selected: false,
              usageComments: "",
              usage: null,
            });
            return eachCat;
          })
          .sort((a: any, b: any) => a.code.localeCompare(b.code));
        setCategoryData(categories);
        preferences.sort((a: any, b: any) => a.category - b.category);
        setCategoryPreferences(preferences);
        return categories;
      })
      .catch((err) => {
        setIsLoading(false);
        toastMessage(err?.response?.data?.message, "error");
        console.log("Error:", err?.response?.data?.message);
      });
  };
  const getInitOptionsFromDefault = (types: any) => {
    let catTypesData = types ? types : [];
    let resMap: any = {};
    catTypesData.forEach((eachType: any) => {
      if (resMap[eachType.type]) {
        resMap[eachType.type].children.push({
          label: eachType.subTypeName,
          value: eachType.subType,
        });
      } else {
        resMap[eachType.type] = {
          label: eachType.typeName,
          value: eachType.type,
          children: [],
        };
        if (eachType.subType) {
          resMap[eachType.type].children.push({
            label: eachType.subTypeName,
            value: eachType.subType,
          });
        }
      }
    });
    return Object.values(resMap);
  };
  const createOrUpdateBusinessUnit = () => {
    setIsLoading(true);
    let reqData: any = { businessUnit: {} };
    reqData.businessUnit = { ...formData };
    reqData.businessUnit.id = reqData.businessUnit.id
      ? parseInt(reqData.businessUnit.id)
      : null;
    reqData.businessUnit.country = formData.country?.value;
    delete reqData.businessUnit.parent;
    let pref = preferenceData;
    pref.currency = currency;
    pref.gwpVersion = gwpVersion;
    pref.carbonPrice = carbonPrice || 0;
    pref.directEmissionApproval = directEmissionApproval;
    if (id && !initialDirectEmissionApproval && directEmissionApproval) {
      pref.approveEmissions = true;
    }
    // pref.categories = categoryData.map(
    //   (eachCategory: any) => eachCategory.id
    // );
    reqData.preference = pref;
    // let finalCatList = categoryPreferences.map(
    //   (eachPreference: any) => eachPreference.category
    // );
    // let initCatList = initCategoryPreferences.map(
    //   (eachPreference: any) => eachPreference.category
    // );
    // reqData.deleteCategories = initCategoryPreferences
    //   .filter((eachCat: any) => !finalCatList.includes(eachCat.category))
    //   .map((eacPref: any) => eacPref.id);
    reqData.categoryPreferences = categoryPreferences.map(
      (eachPreference: any) => {
        if ("id" in eachPreference && isClone) {
          // this block works for cloning
          delete eachPreference.id;
        }
        return eachPreference;
      }
    );
    // .filter((eachPreference: any) => eachPreference.isAdded || isClone);

    createOrUpdateBusinessUnitAction(reqData, initialData)
      .then((res) => {
        toastMessage(
          "Facility " +
            (reqData?.businessUnit?.id ? "Updated" : "Created") +
            " Successfully",
          "success"
        );
        let bunits = localStorage.getItem("businessUnits")
          ? JSON.parse(localStorage.getItem("businessUnits") || "{}")
          : [];
        if (!reqData?.businessUnit.id) {
          if (bunits.length === 0) {
            localStorage.setItem(
              "currentBusinessUnit",
              JSON.stringify({ id: res.data.businessUnit.id })
            );
            localStorage.setItem(
              "categoryPreferences",
              JSON.stringify(res.data.categoryPreferences)
            );
            localStorage.setItem("bunits", res.data.businessUnit.id);
          } else {
            let bunitIds = localStorage.getItem("bunits") || "";
            bunitIds = bunitIds += "," + res.data.businessUnit.id;
            localStorage.setItem("bunits", bunitIds);
          }
          bunits.push(res.data.businessUnit);
          // dispatch(setBunits(bunits));
        } else {
          bunits = bunits.map((eachbunit: any) => {
            if (eachbunit.id === parseInt(reqData.businessUnit.id)) {
              return reqData.businessUnit;
            }
            return eachbunit;
          });
        }
        localStorage.setItem("businessUnits", JSON.stringify(bunits));
        navigate("/organisation/facility");
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toastMessage(err?.response?.data?.message, "error");
        console.log("Error:", err.response.data.message);
      });
  };
  const fillBUnitData = (categoryData: any) => {
    return fetchBusinessUnit(businessUnitId, { fetchAllPreferences: true })
      .then((res: any) => {
        setInitialData(res.data);
        const data = res.data.businessUnit;
        if (data) {
          setDefaultAddress({
            addressLine1: data?.address?.addressLine1,
            addressLine2: "",
            city: data?.address?.city,
            cityCode: data?.address?.cityCode || "",
            state: data?.address?.state,
            stateCode: data?.address?.stateCode,
            country: data?.address?.country,
            countryCode: data?.address?.countryCode,
            timeZone:
              data?.address?.timeZone ||
              Intl.DateTimeFormat().resolvedOptions().timeZone,
            company: data?.address?.company || "",
          });
          const formData = {
            id: isClone ? "" : businessUnitId,
            code: isClone ? "" : data.code,
            name: isClone ? data.name + "- Copy" : data.name,
            registrationId: isClone ? "" : data.registrationid,
            imageUrl: data.imageurl,
            company: data.company,
            type: data.type,
            typeName: data.typename,
            parentIndustryName: data.parentindustrycode,
            childIndustryName: data.industryname,
            industry: data.industry,
            mobile: data.mobile || null,
            email: data.email,
            facilityBoundary: data.facility_boundary,
            phone:
              data.dialcode && data.mobile
                ? data.dialcode + " " + data.mobile
                : "",
            dialCode: data.dialcode,
            address: {
              addressLine1: data?.address?.addressLine1,
              addressLine2: "",
              city: data?.address?.city,
              cityCode: data?.address?.cityCode || "",
              state: data?.address?.state,
              stateCode: data?.address?.stateCode,
              country: data?.address?.country,
              countryCode: data?.address?.countryCode,
              timeZone:
                data?.address?.timezone ||
                Intl.DateTimeFormat().resolvedOptions().timeZone,
              company: data?.address?.company || "",
            },
            country: data.country
              ? countryOptions.find((o: any) => o.value === data.country)
              : { value: "IN", label: "India" },
            parent: data?.parent || "",
            incharge: data?.incharge,
            inchargeName: data?.inchargename,
            owner: data?.owner,
            timeZone: data?.timezone || "",
          };
          setFormData({ ...formData });

          if (res.data.categoryPreferences) {
            setInitCategoryPreferences(res.data.categoryPreferences);
            fillBUnitPreferenceData(res.data.categoryPreferences, categoryData);
          }
          if (res.data.businessUnitPreferences) {
            setCurrency(res.data.businessUnitPreferences.currency);
            setCarbonPrice(
              res.data.businessUnitPreferences.carbonPrice || null
            );
            setDirectEmissionApproval(
              res.data.businessUnitPreferences.directEmissionApproval
            );
            initialDirectEmissionApproval =
              res.data.businessUnitPreferences.directEmissionApproval;
          }
        }
      })
      .catch((e) => {
        toastMessage(e.response.data.message, "error");
      });
  };
  const fillBUnitPreferenceData = (
    catPreferencesData: any,
    categoryData: any
  ) => {
    let key =
      localStorage.getItem("protocol") == "ghg" ? "ghgCategory" : "category";
    //setting  category list checkboxs
    let catMap = new Map();
    let catData = categoryData.map((eachCat: any, catDataIndex: number) => {
      let catIndex = catPreferencesData.findIndex(
        (eachPref: any) => eachPref[key] === eachCat.id
      );

      if (catIndex > -1) {
        catMap.set(eachCat.id, catDataIndex);

        eachCat.selected = catPreferencesData[catIndex].selected || false;
        eachCat.showComments = false;
        eachCat.usageComments =
          catPreferencesData[catIndex].usageComments || "";
        eachCat.usage = catPreferencesData[catIndex].usage || null;
        return eachCat;
      } else {
        eachCat.selected = false;
        eachCat.showComments = false;
        eachCat.usageComments = "";
        eachCat.usage = null;
        return eachCat;
      }
    });
    setCategoryData([...catData]);

    //setting categoryPreferences
    let preferences: any[] = [];
    preferences = catPreferencesData.map((eachPreference: any) => {
      return {
        id: eachPreference.id,
        category: eachPreference[key],
        name:
          catData[catMap.get(eachPreference[key])].code +
          " - " +
          catData[catMap.get(eachPreference[key])].name,
        subTypes: getInitOptionsFromDefault(eachPreference.emissionSources),
        emissionSources: eachPreference.emissionSources,
        methods: eachPreference.methods,
        emissionTypeName: eachPreference.emissionTypeName,
        emissionType: eachPreference.emissionType,
        emissionSubType: eachPreference.emissionSubType,
        // ,value:{type: eachPreference.type, subType:eachPreference.type ,emissionTypeName: eachPreference.emissionTypeName}
        selected: eachPreference.selected || false,
        usageComments: eachPreference.usageComments || "",
        usage:
          eachPreference.usage || (eachPreference.selected ? "fully" : null),
      };
    });
    categoryData.forEach((eachCategory: any) => {
      let preferenceIndex = preferences.findIndex(
        (eachPref: any) => eachPref.category === eachCategory.id
      );
      if (preferenceIndex === -1) {
        preferences.push({
          category: eachCategory.id,
          name: eachCategory.code + " - " + eachCategory.name,
          subTypes: [],
          emissionFactorSourceName: null,
          methods: [],
          logEmissionAgainst: "",
          isAdded: true,
          selected: false,
          usageComments: "",
          usage: null,
        });
      }
    });
    preferences.sort((a: any, b: any) => a.category - b.category);
    setCategoryPreferences(preferences);
  };

  return (
    <div className="pw-bunit-home w-full  flex flex-row grow">
      <div className="pw-creation-side-bar pw-overflow-y-auto">
        <div
          className={`pw-usetiful-facility pw-org-side-elem text-neutral-700 cursor-pointer text-sm ${
            step === STEPS.ADD_UNIT
              ? isPreferenceClicked
                ? "pw-org-inactive"
                : "pw-org-active"
              : "pw-org-inactive"
          }`}
          onClick={() => {
            setStep(STEPS.ADD_UNIT);
            setIsPreferenceClicked(false);
          }}
        >
          {id ? t("Edit") : t("Add")}&nbsp; {t("Facility")}
        </div>
        <div className="font-semibold text-neutral-400 text-xs pl-5 mb-2 mt-4 ">
          {t("Facility Preferences")}
        </div>
        <div
          className={`pw-usetiful-basic pw-org-side-elem text-neutral-700 cursor-pointer text-sm ${
            step === STEPS.ADD_PREFERENCE
              ? isPreferenceClicked
                ? "pw-org-inactive"
                : "pw-org-active"
              : "pw-org-inactive"
          }`}
          onClick={() => {
            setIsPreferenceClicked(false);
            setStep(STEPS.ADD_PREFERENCE);
            setSelectedId(-1);
          }}
        >
          {t("Basic")}
        </div>
        {categoryData
          ?.filter((eachCategory: any) => eachCategory.selected)
          .map((eachCategory: any) => (
            <div
              key={eachCategory.id}
              className={`pw-org-side-elem text-sm cursor-pointer text-sm ${
                selectedId === eachCategory.id && isPreferenceClicked
                  ? "pw-org-active"
                  : "pw-org-inactive"
              }`}
              onClick={() => {
                setIsPreferenceClicked(true);
                setSelectedId(eachCategory.id);
              }}
            >
              {eachCategory.code} - {eachCategory.name}
            </div>
          ))}
      </div>
      <div className=" pw-bunit-home-main bg-neutral-100">
        <div style={{ display: step === STEPS.ADD_UNIT ? "block" : "none" }}>
          <BusinessUnitCreation
            id={id}
            setStep={setStep}
            formData={formData}
            defaultAddress={defaultAddress}
            setFormData={setFormData}
            countryOptions={countryOptions}
            fillBUnitData={fillBUnitData}
            industries={industries}
            setIndustries={setIndustries}
          />
        </div>
        <div style={{ display: step === STEPS.ADD_UNIT ? "none" : "block" }}>
          <BusinessUnitPreferences
            id={id}
            setStep={setStep}
            selectedId={selectedId}
            categoryData={categoryData}
            setCategoryData={setCategoryData}
            categoryPreferences={categoryPreferences}
            setCategoryPreferences={setCategoryPreferences}
            initCategoryPreferences={initCategoryPreferences}
            defaultCategoryPreferences={defaultCategoryPreferences}
            countries={countriesData}
            currency={currency}
            setCurrency={setCurrency}
            setGwpVersion={setGwpVersion}
            gwpVersion={gwpVersion}
            carbonPrice={carbonPrice}
            setCarbonPrice={setCarbonPrice}
            directEmissionApproval={directEmissionApproval}
            setDirectEmissionApproval={setDirectEmissionApproval}
            createOrUpdateBusinessUnit={createOrUpdateBusinessUnit}
            isLoading={isLoading}
          />
        </div>
      </div>
    </div>
  );
};

export default OrganisationHome;
